import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BrandWordmark } from '../brand/BrandWordmark';
import { PublicLayout } from './PublicLayout';

const shell = 'mx-auto w-full max-w-[75rem] px-4 sm:px-6 lg:px-8';

export function PublicLegalShell({ title, eyebrow, children }) {
  return (
    <PublicLayout className="bg-[hsl(42_28%_96%)] text-foreground">
      <header className="border-b border-[hsl(38_14%_86%)] bg-[hsl(42_28%_99%)]/95">
        <div className={`${shell} flex items-center justify-between gap-4 py-4`}>
          <div className="flex min-w-0 items-center gap-3">
            <Link
              to="/"
              className="inline-flex shrink-0 items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" />
              <span className="hidden sm:inline">Home</span>
            </Link>
            <BrandWordmark variant="navLanding" className="hidden sm:inline" />
          </div>
          <Link
            to="/faq"
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            FAQ
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className={`${shell} py-12 md:py-16`}>
          {eyebrow ? (
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.2em] text-[hsl(38_36%_42%)]">
              {eyebrow}
            </p>
          ) : null}
          <h1 className="mt-2 max-w-3xl font-serif text-3xl font-light text-[hsl(24_14%_16%)] sm:text-4xl">
            {title}
          </h1>
          <div className="prose-legal mt-8 max-w-2xl space-y-6 text-sm leading-relaxed text-[hsl(32_10%_38%)]">
            {children}
          </div>
        </div>
      </main>
    </PublicLayout>
  );
}

export default PublicLegalShell;
